import { render, staticRenderFns } from "./DetailsDialog.vue?vue&type=template&id=e42837be&scoped=true"
import script from "./DetailsDialog.vue?vue&type=script&lang=ts"
export * from "./DetailsDialog.vue?vue&type=script&lang=ts"
import style0 from "./DetailsDialog.vue?vue&type=style&index=0&id=e42837be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42837be",
  null
  
)

export default component.exports